export default __webpack_public_path__ + "static/dmc-dashboard-d4af9d3ed9f4e13188e1a45e27a42f0d.png";